export const STORAGE_USER_TOKEN = 'is2/token'
export const STORAGE_LAST_REQUEST_TIMESTAMP = 'is2/lastRequestTimestamp'
export const STORAGE_REDIRECT_URI = 'is2/redirectUri'
export const STORAGE_TOUR = 'is2/tour'
